import { Filter, FilterType, FilterKey, EApplicantOfferPGKeys } from 'types';
import { orderBy } from 'lodash';
import { IGetFilterGroupsProps } from '..';

const key = FilterKey.APPLICATION_COUNTRY;
export const getApplicationCountryFilter = ({ activeFilters, filterOptions }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  let applicationCountryFilterOptions = filterOptions?.[EApplicantOfferPGKeys.APPLICATION_COUNTRY] || [];
  if (!applicationCountryFilterOptions) {
    console.warn('Application country filter options could not be extracted from filter options.');
    applicationCountryFilterOptions = [];
  }
  const options = applicationCountryFilterOptions.map(country => {
    return {
      label: country.label,
      value: country.value,
      checked: filters.some(filter => filter === country.value),
    };
  });

  const sortedOptions = orderBy(options, [option => option.label.toLowerCase()], ['asc']);

  return {
    name: 'Application country',
    key,
    type: FilterType.SELECT_MANY,
    showSearch: true,
    options: {
      SELECT_MANY: sortedOptions,
    },
  };
};
